import Icon from '../components/Icon.vue'

Icon.register({
  blog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M172.2 226.8C157.6 223.9 144 235.7 144 250.6V301C144 311.2 151.1 319.4 160.7 323 178.9 329.8 192 347.4 192 368 192 394.5 170.5 416 144 416S96 394.5 96 368V120C96 106.7 85.3 96 72 96H24C10.7 96 0 106.7 0 120V368C0 457.5 82.1 528.2 175 508.7 229.4 497.3 273.3 453.3 284.7 399 302.1 316.1 247.7 241.8 172.2 226.8zM209 0C199.8-0.5 192 6.8 192 16V47.6C192 56.1 198.6 63.1 207 63.5 336.4 70.5 440.4 175.5 447.9 305 448.4 313.4 455.4 320 463.8 320H495.9C505.1 320 512.4 312.2 511.9 303 503.4 139.8 372.2 8.6 209 0zM209.3 96C200 95.3 192 102.7 192 112.1V144.2C192 152.6 198.5 159.5 206.8 160.1 283.6 166.4 344.8 228.3 351.7 305.3 352.5 313.6 359.3 320 367.6 320H399.8C409.1 320 416.6 312 415.9 302.7 407.5 192.6 319.4 104.5 209.3 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blog.js
// module id = m7pf
// module chunks = 144